import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import Pagination, { usePagination } from "@/components/app/Pagination";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function AuditLog() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [logs, setLogs] = useState([]);
  const [selected, setSelected] = useState(new Set());

  const load = async () => {
    try { const r = await api.get("/audit-logs?limit=1000"); setLogs(r.data.items || r.data); }
    catch(e){ toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const { page, setPage, totalPages, paged, total, pageSize } = usePagination(logs, 20);

  const delOne = async (id) => {
    if (!window.confirm("Hapus log ini?")) return;
    try { await api.delete(`/audit-logs/${id}`); toast.success("Log dihapus"); load(); }
    catch(e){ toast.error(formatApiError(e)); }
  };

  const bulkDel = async () => {
    if (!selected.size || !window.confirm(`Hapus ${selected.size} log?`)) return;
    try { await api.post("/audit-logs/bulk-delete", { ids: Array.from(selected) });
      setSelected(new Set()); toast.success("Log dihapus"); load();
    } catch(e){ toast.error(formatApiError(e)); }
  };

  const toggle = (id) => { const s = new Set(selected); s.has(id)?s.delete(id):s.add(id); setSelected(s); };
  const toggleAllPage = () => {
    const ids = paged.map(l => l.id);
    if (ids.every(id => selected.has(id))) { const s = new Set(selected); ids.forEach(id => s.delete(id)); setSelected(s); }
    else { const s = new Set(selected); ids.forEach(id => s.add(id)); setSelected(s); }
  };
  const allSelectedOnPage = paged.length > 0 && paged.every(l => selected.has(l.id));

  return (<>
    <PageHeader title="Log Aktivitas" subtitle="Riwayat aksi di workspace ini."
      actions={isAdmin && selected.size > 0 && (
        <Button variant="outline" onClick={bulkDel} className="rounded-sm" data-testid="bulk-del-audit">
          <Trash2 size={14} className="mr-1"/> Hapus ({selected.size})
        </Button>
      )}/>
    <div className="p-4 md:p-8">
      <div className="card-flat overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-xs md:text-sm" data-testid="audit-table">
            <thead>
              <tr className="bg-slate-50 border-b text-left text-[11px] uppercase text-slate-500">
                {isAdmin && <th className="p-3 w-10"><Checkbox checked={allSelectedOnPage} onCheckedChange={toggleAllPage}/></th>}
                <th className="p-3">Waktu</th><th className="p-3">User</th>
                <th className="p-3">Peran</th><th className="p-3">Aksi</th>
                <th className="p-3">Entity</th><th className="p-3">Detail</th>
                {isAdmin && <th className="p-3 text-right">Hapus</th>}
              </tr>
            </thead>
            <tbody>
              {paged.length === 0 && <tr><td colSpan={isAdmin?8:6} className="text-center py-10 text-slate-400">Belum ada aktivitas.</td></tr>}
              {paged.map(l => (
                <tr key={l.id} className="border-b hover:bg-slate-50">
                  {isAdmin && <td className="p-3"><Checkbox checked={selected.has(l.id)} onCheckedChange={()=>toggle(l.id)}/></td>}
                  <td className="p-3 text-[12px] font-mono">{l.at?.slice(0,19).replace("T"," ")}</td>
                  <td className="p-3">{l.user_email}</td>
                  <td className="p-3"><span className="text-[11px] px-2 py-0.5 brand-soft brand-text rounded-sm">{l.user_role}</span></td>
                  <td className="p-3 text-[12px]">{l.action}</td>
                  <td className="p-3 text-[12px]">{l.entity}</td>
                  <td className="p-3 text-[12px] text-slate-500">{l.detail}</td>
                  {isAdmin && (
                    <td className="p-3 text-right">
                      <button onClick={()=>delOne(l.id)} className="p-1.5 rounded-sm hover:bg-rose-50" data-testid={`del-audit-${l.id}`}>
                        <Trash2 size={14} className="text-rose-600"/>
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} total={total} pageSize={pageSize} testid="audit-pagination"/>
      </div>
    </div>
  </>);
}
